export async function handleStripeErrors(stripeCall) {
    const { error, ...rest } = await stripeCall();
    if (error) {
        throw new Error(error.message);
    }
    return rest;
}

export async function handlePaymentIntentResult(stripe, { status, client_secret, payment_method }) {
    if (status === "succeeded") {
        return;
    }

    if (status === "requires_setup_action") {
        await handleStripeErrors(() => stripe.confirmCardSetup(client_secret, {
            payment_method
        }));
        return;
    }

    if (status === "requires_action") {
        await handleStripeErrors(() => stripe.confirmCardPayment(client_secret, {
            payment_method
        }));
        return;
    }

    if (status === "requires_payment_method") {
        throw new Error("Payment method is missing or invalid.");
    }

    throw new Error("Unexpected error occurred.");
}
